var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return (_vm.loading)?_c('v-overlay',[_c('v-progress-circular',{attrs:{"size":"150","width":"10","color":"primary","indeterminate":""}})],1):_vm._e()}
var staticRenderFns = []

export { render, staticRenderFns }